


























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import isMobile from '@/utils/mobile-check';
import { getLabelInfo } from '@/utils/getLabelInfo';
import { toNumber } from '@/utils/moneyTreatments';
import { scrollToTop } from '@/utils/scrollToTop';
import segmentIo from '@/utils/segment.io';

import HTTPStatus from '@/constants/httpStatus';
import flagKeys from '@/constants/flagKeys';

import {
  IFirstOfferCreationData,
  IOfferDiscountType,
  IOfferDiscountTypeName,
  IOfferMethod,
  EOfferTypeEnum,
  ESpecialOfferRules,
  EOfferRulesName,
  getRenewedValue,
  IOfferLocationItem,
  IOfferDetailsData,
  IOfferAdvancedOptionsData,
  SpecialOfferTypeEnum,
  getOfferTagByType,
  IOfferRedemptionRulesSectionData,
  IOfferEdit,
  IOfferType
} from '@/models/offer';
import { IBusinessType } from '@/models/business';
import { ILocation } from '@/models/location';
import { ALL_WEEKDAYS_VALUE, WEEKDAY_INDEXES } from '@/api/OpeningHoursService';

import { FilledButton } from '@/components/molecules';
import ExternalLink from '@/components/icons/ExternalLink.vue';

import { SPECIAL_OFFER_PREVIEW_STORAGE_KEY } from '@/store/modules/offer';

import LocationsService from '@/api/LocationsService';

import OfferDetails from './Sections/OfferDetails.vue';
import AdvancedOptions from './Sections/AdvancedOptions.vue';
import OverviewSidebar from './Sections/OverviewSidebar.vue';
import RedemptionRules from './Sections/RedemptionRules.vue';
import FinePrint from './Sections/FinePrint.vue';
import eventBus from '@/utils/eventBus';
import { IBusiness } from '@/store/modules/managerTypes';
import { isRemoteLoading } from '@/utils/remote-loading';

export enum PromoCodeOption {
  OFFER_WITH_PROMO_CODE = 'offer_with_promo_code',
  OFFER_WITHOUT_PROMO_CODE = 'offer_without_promo_code'
}

export interface IDataOffer
  extends IOfferDetailsData,
    IOfferAdvancedOptionsData,
    IOfferRedemptionRulesSectionData {}

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    OverviewSidebar,
    ExternalLink,
    OfferDetails,
    AdvancedOptions,
    RedemptionRules,
    FinePrint
  }
})
export default class FormOffer extends Vue {
  @Prop({ default: '' }) defaultOfferProductType!: SpecialOfferTypeEnum;
  @Prop({ default: false }) loading?: boolean;
  @Prop() offer?: IOfferEdit;
  @Prop() offerLocations?: ILocation[];
  @Prop() imageOptional?: boolean;
  @Prop() offerBusiness?: IBusiness;
  @Prop() showOverview?: boolean;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  locationService = new LocationsService();

  locations: Array<ILocation> = [];
  transformedLocations: Array<IOfferLocationItem> = [];

  @Watch('offer', { immediate: true })
  onOfferChange(newOffer: IOfferEdit) {
    if (newOffer && Object.keys(newOffer).length > 0) {
      // Convert IOfferEdit to IDataOffer format

      const discountType = newOffer.discount
        ? newOffer.discount.typeName === IOfferDiscountTypeName.PERCENTAGE
          ? IOfferDiscountType.PERCENTAGE
          : IOfferDiscountType.AMOUNT
        : IOfferDiscountType.AMOUNT;
      const convertedData = {
        title: newOffer.title || '',
        discountType,
        description: newOffer.description || '',
        type: newOffer.type || IOfferType.GENERAL,
        specialType: newOffer.specialType,
        discountAmount: newOffer.discount ? newOffer.discount.value : '',
        // Convert rules array to object format required by IDataOffer
        rules: this.formRules,
        availability: this.formAvailability,
        additionalRules: this.formAdditionalRules,
        restrictions: newOffer.restrictions || '',
        promoCodeOption:
          newOffer.type === IOfferType.GENERAL
            ? PromoCodeOption.OFFER_WITH_PROMO_CODE
            : PromoCodeOption.OFFER_WITHOUT_PROMO_CODE,
        link: {
          [PromoCodeOption.OFFER_WITH_PROMO_CODE]: newOffer.discountCode || '',
          [PromoCodeOption.OFFER_WITHOUT_PROMO_CODE]: ''
        },
        locations: newOffer.locations || [],
        imageId: newOffer.image ? newOffer.image.id : '',
        imageLink: newOffer.image ? newOffer.image.url : '',
        originalPrice: newOffer.discount ? newOffer.discount.originalValue : '',
        savingsCannotBeDetermined: newOffer.savingsCannotBeDetermined || false,
        avgDiscountValue:
          newOffer.avgDiscountValue && newOffer.avgDiscountValue != '0.00'
            ? newOffer.avgDiscountValue
            : ''
      };

      this.data = {
        ...this.data,
        ...convertedData
      };
    }
  }

  offerProductType: SpecialOfferTypeEnum = this.defaultOfferProductType;

  data: IDataOffer = {
    title: '',
    discountType: IOfferDiscountType.AMOUNT,
    discountAmount: '',
    imageId: '',
    imageLink: '',
    originalPrice: '',
    selectedLocations: [],
    description: '',
    redeemMethod: {
      value: IOfferMethod.INSTORE,
      label: ''
    },
    discountCode: '',
    link: {
      [PromoCodeOption.OFFER_WITH_PROMO_CODE]: '',
      [PromoCodeOption.OFFER_WITHOUT_PROMO_CODE]: ''
    },
    promoCodeOption: PromoCodeOption.OFFER_WITH_PROMO_CODE,
    rules: {
      [ESpecialOfferRules.SUPPLY_RULE]: {
        enabled: false,
        value: ''
      },
      [ESpecialOfferRules.EXPIRATION_RULE]: {
        enabled: false,
        value: ''
      },
      [ESpecialOfferRules.COMBINED_RULE]: {
        enabled: false
      }
    },
    restrictions: '',
    availability: {
      [EOfferRulesName.REDEEMABLE_DAY_RULE]: {
        enabled: true,
        value: ''
      },
      [EOfferRulesName.REDEEMABLE_HOUR_RULE]: {
        enabled: this.offerProductType !== SpecialOfferTypeEnum.HAPPY_HOUR,
        value: ''
      }
    },
    additionalRules: {
      [ESpecialOfferRules.LIMIT_RULE]: { enabled: false, value: '1' },
      [ESpecialOfferRules.RENEWED_RULE]: { enabled: false, value: 'yearly:1' }
    },
    avgDiscountValue: '',
    savingsCannotBeDetermined: false
  };

  errors: string[] = [];

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return 'offers.form';
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  get websiteFieldOnOfferCreationIsActivated() {
    return this.flags.includes(flagKeys.websiteFieldOnOfferCreation);
  }

  get isHappyHour() {
    return this.offerProductType === SpecialOfferTypeEnum.HAPPY_HOUR;
  }

  get offerType() {
    if (this.isHappyHour) return EOfferTypeEnum.HAPPY_HOUR;
    if (this.offerProductType === SpecialOfferTypeEnum.BIRTHDAY)
      return EOfferTypeEnum.BIRTHDAY;
    if (this.offerProductType === SpecialOfferTypeEnum.PRODUCT_AND_SERVICE)
      return EOfferTypeEnum.STOREWIDE;

    return EOfferTypeEnum.GENERAL;
  }

  get formRules() {
    const rulesDefault = { ...this.data.rules };

    const rules = this.offer && this.offer.rules ? this.offer.rules : [];

    const rulesSupply = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.SUPPLY_RULE
    )[0];
    const rulesCombine = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.COMBINE_RULE
    )[0];

    if (rulesCombine)
      rulesDefault[ESpecialOfferRules.COMBINED_RULE] = {
        enabled: !!rulesCombine,
        value: `${!!rulesCombine}`
      };

    if (rulesSupply)
      rulesDefault[ESpecialOfferRules.SUPPLY_RULE] = {
        enabled: !!rulesSupply,
        value: rulesSupply.value
      };

    if (this.offer && this.offer.expirationDate) {
      rulesDefault[ESpecialOfferRules.EXPIRATION_RULE] = {
        enabled: true,
        value: this.offer.expirationDate
      };
    }

    return rulesDefault;
  }

  get formAvailability() {
    const rulesDefault = { ...this.data.availability };
    const rules = this.offer && this.offer.rules ? this.offer.rules : [];
    const rulesDay = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.REDEEMABLE_DAY_RULE
    )[0];
    const rulesHour = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.REDEEMABLE_HOUR_RULE
    )[0];

    if (rulesDay) {
      // Mirror the create-form select-all invariant on edit: a stored rule
      // covering every weekday is "Redeemable on any day" (toggle on, empty
      // value); a partial list keeps the explicit days with the toggle off.
      const storedDays = rulesDay.value
        ? rulesDay.value.split(',').filter((day: string) => day.trim())
        : [];
      const isAnyDay = storedDays.length === WEEKDAY_INDEXES.length;
      rulesDefault[EOfferRulesName.REDEEMABLE_DAY_RULE] = {
        enabled: isAnyDay,
        value: isAnyDay ? '' : rulesDay.value
      };
    }
    if (rulesHour)
      rulesDefault[EOfferRulesName.REDEEMABLE_HOUR_RULE] = {
        enabled: false,
        value: rulesHour.value
      };
    return rulesDefault;
  }

  get formAdditionalRules() {
    const rulesDefault = { ...this.data.additionalRules };
    const rules = this.offer && this.offer.rules ? this.offer.rules : [];
    const rulesLimit = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.LIMIT_RULE
    )[0];
    const rulesRenewed = rules.filter(
      (rule: any) => rule.name === EOfferRulesName.RENEWED_RULE
    )[0];

    if (rulesLimit)
      rulesDefault[ESpecialOfferRules.LIMIT_RULE] = {
        enabled: !!rulesLimit,
        value: rulesLimit.value
      };
    if (rulesRenewed)
      rulesDefault[ESpecialOfferRules.RENEWED_RULE] = {
        enabled: !!rulesRenewed,
        value: rulesRenewed.value
      };
    return rulesDefault;
  }

  get expirationDate() {
    const data = this.data.rules[ESpecialOfferRules.EXPIRATION_RULE];
    if (!data || !data.enabled) return '';
    return data.value;
  }

  get rules() {
    const rules: any = [];
    if (
      !this.isHappyHour &&
      this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE] &&
      this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE].enabled
    ) {
      rules.push({
        name: EOfferRulesName.LIMIT_RULE,
        value:
          this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE].value || '1'
      });
      rules.push({
        name: EOfferRulesName.RENEWED_RULE,
        value: this.data.additionalRules[ESpecialOfferRules.RENEWED_RULE].value
      });
    }

    if (
      !this.isHappyHour &&
      this.data.rules[ESpecialOfferRules.SUPPLY_RULE] &&
      this.data.rules[ESpecialOfferRules.SUPPLY_RULE].enabled
    )
      rules.push({
        name: EOfferRulesName.SUPPLY_RULE,
        value: this.data.rules[ESpecialOfferRules.SUPPLY_RULE].value
      });

    const redeemableDayValue = this.data.availability[
      EOfferRulesName.REDEEMABLE_DAY_RULE
    ].value;
    if (redeemableDayValue)
      rules.push({
        name: EOfferRulesName.REDEEMABLE_DAY_RULE,
        value: redeemableDayValue
      });
    // Happy Hour must always carry a day rule: the backend
    // (hasValidHappyHourSchedule) rejects create/update without one, and the
    // mobile day-filter/"happening now" needs it. "Redeemable on any day" =>
    // all weekdays.
    else if (this.isHappyHour)
      rules.push({
        name: EOfferRulesName.REDEEMABLE_DAY_RULE,
        value: ALL_WEEKDAYS_VALUE
      });

    if (this.data.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE].value)
      rules.push({
        name: EOfferRulesName.REDEEMABLE_HOUR_RULE,
        value: this.data.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE]
          .value
      });

    rules.push({
      name: EOfferRulesName.COMBINE_RULE,
      value: `${this.data.rules[ESpecialOfferRules.COMBINED_RULE] &&
        this.data.rules[ESpecialOfferRules.COMBINED_RULE].enabled}`
    });

    if (this.offerProductType === SpecialOfferTypeEnum.TWO_FOR_ONE) {
      rules.push({
        name: EOfferRulesName.TWO_FOR_ONE_RULE,
        value: 'true'
      });
    }

    return rules;
  }

  get formattedData() {
    const redeemMethod = this.data.redeemMethod.value as IOfferMethod;
    const offerLink = this.data.link[this.data.promoCodeOption];

    const shouldAddLinkProperty =
      (redeemMethod !== IOfferMethod.INSTORE &&
        this.business.website !== offerLink) ||
      this.data.promoCodeOption === PromoCodeOption.OFFER_WITHOUT_PROMO_CODE;

    const res: any = {
      title: this.data.title.trim(),
      type: this.offerType,
      method: redeemMethod,
      discount: {
        typeName: this.discountTypeName,
        value: getOfferTagByType(
          this.offerProductType,
          this.data.discountAmount.replace(/[^0-9.]+/g, '')
        ),
        originalValue: this.data.originalPrice || '0'
      },
      specialType: this.offerProductType,
      rulesOverview: {
        ...this.data.rules,
        ...this.data.availability,
        ...this.data.additionalRules
      },
      rules: this.rules,
      discountCode:
        this.data.promoCodeOption === PromoCodeOption.OFFER_WITH_PROMO_CODE
          ? this.data.discountCode
          : '',
      ...(this.data.imageLink || this.data.imageId
        ? {
            imageId: this.data.imageId,
            imageSrc: this.data.imageLink
          }
        : {}),
      avgDiscountValue: this.data.savingsCannotBeDetermined
        ? '0.00'
        : this.data.avgDiscountValue ||
          this.data.discountAmount.replace(/[^0-9.]+/g, ''),
      savingsCannotBeDetermined: this.data.savingsCannotBeDetermined,
      business: this.business.id,
      description: this.data.description,
      restrictions: this.data.restrictions,
      ...(redeemMethod !== IOfferMethod.ONLINE && {
        locations: this.data.selectedLocations.map(location => location.id)
      }),
      ...(shouldAddLinkProperty &&
        offerLink && {
          link: offerLink
        }),
      ...(this.websiteFieldOnOfferCreationIsActivated && {
        promoCodeOption: this.data.promoCodeOption
      })
    };
    if (this.expirationDate) res.expirationDate = this.expirationDate;

    if (this.offerProductType === SpecialOfferTypeEnum.BIRTHDAY) {
      res.method = IOfferMethod.INSTORE;
      res.discount = {
        ...res.discount,
        value: 'Birthday Club'
      };
    }

    return res;
  }

  get characterLimitationIsActivated() {
    return !this.flags.includes(flagKeys.disableCharacterLimitationOnOffer);
  }

  get shouldShowMethodSelect() {
    return this.business.type === IBusinessType.BOTH;
  }

  get showRedemptionRules() {
    return !this.isBirthday;
  }

  get shouldShowDiscountAmount() {
    return this.offerProductType === SpecialOfferTypeEnum.PRODUCT_AND_SERVICE;
  }

  get isBirthday() {
    return this.offerProductType === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get shouldShowDiscountCode() {
    const redeemMethod = this.data.redeemMethod.value;

    return (
      redeemMethod === IOfferMethod.ONLINE ||
      redeemMethod === IOfferMethod.BOTH ||
      this.business.type === IBusinessType.ONLINE
    );
  }

  get shouldShowRedemptionSection() {
    if (
      this.business.type === IBusinessType.ONLINE ||
      (this.data.redeemMethod &&
        this.data.redeemMethod.value === IOfferMethod.ONLINE)
    ) {
      return false;
    }

    return this.transformedLocations.length > 1;
  }

  get discountTypeName() {
    if (this.shouldShowDiscountAmount) {
      if (this.data.discountType === IOfferDiscountType.PERCENTAGE) {
        return IOfferDiscountTypeName.PERCENTAGE;
      }

      return IOfferDiscountTypeName.AMOUNT;
    }

    return IOfferDiscountTypeName.OPEN_TEXT_FIELD;
  }

  get business() {
    const store = this.$store.getters['business/getBusinessInfo'];
    if (store && store.business) {
      return store.business;
    } else {
      return this.offerBusiness || {};
    }
  }

  get hasPropOffer() {
    return this.offer && Object.keys(this.offer).length > 0;
  }

  get selectedLocationsData() {
    const selectedIds = this.data.selectedLocations.map(item => item.id);

    return this.locations.filter(location => selectedIds.includes(location.id));
  }

  get defaultMessageError() {
    const defaultMessage = String(this.$t('common.alerts.fieldsError'));

    return defaultMessage;
  }

  mounted() {
    this.loadLocations();
  }

  @Watch('formattedData')
  changeOffer() {
    if (localStorage.getItem(SPECIAL_OFFER_PREVIEW_STORAGE_KEY)) {
      localStorage.setItem(
        SPECIAL_OFFER_PREVIEW_STORAGE_KEY,
        JSON.stringify(this.formattedData)
      );
    }
  }

  formattedLocations(locations: any[]): IOfferLocationItem[] {
    return locations.map(location => ({
      id: location.id,
      checked: this.hasPropOffer
        ? !!this.data.selectedLocations.filter(
            (item: any) => item.id === location.id
          ).length
        : true,
      label: getLabelInfo(
        ['address', 'city', 'state', 'zip', 'country'],
        location
      )
    }));
  }

  async loadLocations() {
    if (this.business && this.business.type === IBusinessType.ONLINE) {
      return;
    }

    if (!this.offerLocations) {
      const { status, data } = await this.locationService.getLocations();

      if (status !== HTTPStatus.OK) return;

      this.locations = data as ILocation[];
    } else {
      this.locations = this.offerLocations;
    }

    const selectedLocations: ILocation[] =
      this.hasPropOffer &&
      this.offer &&
      this.offer.locations &&
      this.offer.locations.length > 0
        ? this.offer.locations
        : this.locations;

    this.data.selectedLocations = this.formattedLocations(selectedLocations);

    this.transformedLocations = this.formattedLocations(this.locations);
  }

  getRedeemedLocations() {
    const redeemMethod = this.data.redeemMethod.value;
    const offerLink = this.data.link[this.data.promoCodeOption];
    const locations = this.selectedLocationsData.map(location => ({
      type: 'physical',
      title: location.name,
      description: getLabelInfo(
        ['address', 'city', 'state', 'zip', 'country'],
        location
      )
    }));

    if (redeemMethod !== IOfferMethod.INSTORE && offerLink) {
      locations.push({
        type: 'website',
        title: 'Website',
        description: offerLink
      });
    }

    return locations;
  }

  handlePreview() {
    const appPreviewUrl = '/special-coins-offers/preview';
    const data = {
      ...this.formattedData,
      redeemedLocations: this.getRedeemedLocations(),
      imageSrc: this.formattedData.imageSrc
        ? encodeURIComponent(this.formattedData.imageSrc)
        : ''
    };
    delete data.rules;
    const offerStr = JSON.stringify(data);
    localStorage.setItem(SPECIAL_OFFER_PREVIEW_STORAGE_KEY, offerStr);

    this.$analytics({
      eventCategory: 'Special Coin Offer | Preview button',
      eventAction: 'click',
      eventLabel: `Clicked on the "Your customers view" button in creation`
    });
    window.open(`${appPreviewUrl}?offer=${encodeURI(offerStr)}`, '_blank');
  }

  async onSubmit() {
    const formRef = this.$refs.observer;

    const formIsValid = await formRef.validate();
    const validationStatus = this.validate();

    segmentIo.track('Clicked Create Offer Button');

    const handleFormErrors = () => {
      setTimeout(() => {
        const firstElementWithError = document.querySelector(
          '[aria-invalid="true"]'
        );

        if (firstElementWithError) {
          const containerEl = firstElementWithError.closest(
            '.form-offer__group-row'
          );

          if (containerEl) {
            containerEl.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }, 0);
    };

    if (validationStatus.error || !formIsValid) {
      handleFormErrors();

      this.$notification(
        validationStatus.error || this.defaultMessageError,
        'error'
      );
      this.errors.push(...validationStatus.fields);

      return;
    }

    this.$emit('submit', this.formattedData);
    scrollToTop('side-modal__scroll');
  }

  validateRenewed(item: any, key: string) {
    if (key !== ESpecialOfferRules.RENEWED_RULE) return;

    return (
      getRenewedValue(item.value).timeNumber === '' ||
      Number(getRenewedValue(item.value).timeNumber) <= 0
    );
  }

  validate() {
    const response = {
      error: '',
      fields: ['']
    };

    const defaultMessage = this.defaultMessageError;

    if (this.shouldShowMethodSelect && !this.data.redeemMethod.value) {
      response.error = defaultMessage;
      response.fields.push('offer-method');
    }

    if (this.shouldShowDiscountAmount && !this.data.discountAmount) {
      response.error = defaultMessage;
      response.fields.push('offer-discount-amount-empty');
    }

    if (this.shouldShowDiscountAmount && !this.data.originalPrice) {
      response.error = defaultMessage;
      response.fields.push('offer-original-price-empty');
    }

    if (
      !this.shouldShowDiscountAmount &&
      !this.data.savingsCannotBeDetermined &&
      !this.data.avgDiscountValue
    ) {
      response.error = defaultMessage;
      response.fields.push('offer-avg-discount-value');
    }

    if (!this.data.title) {
      response.error = defaultMessage;
      response.fields.push('offer-title');
    }

    if (!this.data.imageLink && !this.imageOptional) {
      response.error = defaultMessage;
      response.fields.push('offer-image');
    }

    const dayRule = this.data.availability[EOfferRulesName.REDEEMABLE_DAY_RULE];
    if (!dayRule.enabled && !dayRule.value) {
      response.error = defaultMessage;
      response.fields.push('day-rule');
    }
    const hourRule = this.data.availability[
      EOfferRulesName.REDEEMABLE_HOUR_RULE
    ];

    if (
      (!hourRule.enabled || this.isHappyHour) &&
      (!hourRule.value ||
        hourRule.value.includes('--') ||
        !hourRule.value.split(',')[0] ||
        !hourRule.value.split(',')[1])
    ) {
      response.error = defaultMessage;
      response.fields.push('hour-rule');
    }

    const rules: any = {
      ...this.data.rules,
      ...this.data.additionalRules
    };

    const keysRules = Object.keys(rules);

    for (let i = 0; i < keysRules.length; i++) {
      const key = keysRules[i] as ESpecialOfferRules;
      const item = rules[key];

      if (
        item.enabled &&
        (item.value === '' ||
          Number(item.value) <= 0 ||
          this.validateRenewed(item, key))
      ) {
        response.error = defaultMessage;
        response.fields.push(key);
      }
    }

    if (!response.error) {
      return this.validateDiscount();
    }

    if (response.error) {
      segmentIo.track('Offer Validation Failed', {
        Error: response.error,
        Fields: response.fields
      });
    }

    return response;
  }

  changedOfferData(data: any) {
    this.data = {
      ...this.data,
      ...data
    };
  }

  validateDiscount() {
    const response = {
      error: '',
      fields: ['']
    };

    const originalPriceIsLowerOrEqualThanDiscount =
      toNumber(this.data.originalPrice) <= toNumber(this.data.discountAmount);

    if (
      this.shouldShowDiscountAmount &&
      this.data.discountType === IOfferDiscountType.AMOUNT &&
      originalPriceIsLowerOrEqualThanDiscount
    ) {
      response.error =
        'The original price must be higher than the discount amount.';
      response.fields = ['offer-original-price'];
    }

    if (this.shouldShowDiscountAmount && +this.data.originalPrice === 0) {
      response.error = 'The original price must be higher than zero.';
      response.fields = ['offer-original-price'];
    }

    if (this.shouldShowDiscountAmount && +this.data.discountAmount === 0) {
      response.error = 'The discount amount must be higher than zero.';
      response.fields = ['offer-discount-amount'];
    }

    if (response.error) {
      segmentIo.track('Offer Validation Failed', { Error: response.error });
    }

    return response;
  }

  clearError(field: string) {
    this.errors = this.errors.filter(eachField => eachField !== field);
  }

  @Watch('formattedData')
  onDataChange(newData: IFirstOfferCreationData) {
    this.$emit('input', newData);
  }

  created() {
    eventBus.$on('saveOffer', this.onSubmit);
  }

  beforeDestroy() {
    eventBus.$off('saveOffer', this.onSubmit);
  }
}
